
let pitelSDK = null;
let sdkReady = null;

export function loadPitelSDK(apiKey) {
  if (sdkReady) return sdkReady;

  sdkReady = new Promise((resolve, reject) => {
    if (window.PitelSDK) return resolve(window.PitelSDK);

    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.onload = () => {
      if (!window.PitelSDK) return reject("PitelSDK không load được");
      window.PitelSDK.k = apiKey;
      resolve(window.PitelSDK);
    };
    s.onerror = () => reject("Load PitelSDK failed");
    s.src = 'https://portal.tel4vn.com/pitelsdk/sdk-latest.min.js';
    document.head.appendChild(s);
  });

  return sdkReady;
}


export async function initSDK(payload) {
  const PitelSDK = await loadPitelSDK('d1ca84ac-2d98-4faa-92d4-699a6ce14eb7'); // chắc chắn SDK đã load

  const sdkOptions = {
    enableWidget: true,
    sipOnly: true,
    sipDomain: payload.sipDomain,
    wsServer: payload.wssServer,
    sipPassword: payload.password,
    contactName: payload.swUsername,
  };

  const sipDelegates = {
    onCallCreated(remoteNumber, extra) {
      console.log('onCallCreated', remoteNumber, extra);

      document.dispatchEvent(new CustomEvent('Pitel_call_created', {
        detail: { remoteNumber, extra }
      }));
    },

    onCallAnswered(remoteNumber, extra) {
      console.log('onCallAnswered', remoteNumber, extra);

      document.dispatchEvent(new CustomEvent('Pitel_call_answered', {
        detail: { remoteNumber, extra }
      }));
    },

    onCallReceived(remoteNumber, extra) {
      console.log('onCallReceived', remoteNumber, extra);

      document.dispatchEvent(new CustomEvent('Pitel_call_received', {
        detail: { remoteNumber, extra }
      }));
    },

    onCallHangup(remoteNumber, extra) {
      console.log('onCallEnded', remoteNumber, extra);

      document.dispatchEvent(new CustomEvent('Pitel_call_ended', {
        detail: { remoteNumber, extra }
      }));
    },
  };

  window.pitelSDK = new PitelSDK('NO_NEED','NO_NEED', payload.deviceCode, sipDelegates, sdkOptions);
  return window.pitelSDK;
}

export function getPitelSDK() {
  return pitelSDK;
}
